import { render } from "./SetupThemeSkeleton.vue?vue&type=template&id=686d7c02"
import script from "./SetupThemeSkeleton.vue?vue&type=script&lang=ts"
export * from "./SetupThemeSkeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script